import '../css/ReleaseDetails.scss'
import { useParams } from 'react-router'
import { useSpotify } from '../contexts/SpotifyProvider'
import React, { useCallback, useState, useEffect } from 'react'
import SpotifyLogo from '../images/spotify/Spotify_Icon_RGB_Green.png'
import { Canvas } from '@react-three/fiber';
import * as THREE from 'three'
import DetailsScene from './threejs/src/DetailsScene'

export default function ReleaseDetails() {
    const { albumId } = useParams()
    const { currentAlbum, getCurrentAlbum, calculateAmountOfItems, setGoBack } = useSpotify()
    const [price, setPrice] = useState(0)
    const [selectedItems, setSelectedItems] = useState([])

    useEffect(() => {
        try {
            setGoBack(true)
            getCurrentAlbum(albumId)

            // Get CartItems
            const itemsFromStorage = JSON.parse(localStorage.getItem('selectedItems')) || []
            setSelectedItems(itemsFromStorage)

            // Get Price
            const pricesFromStorage = JSON.parse(localStorage.getItem('albumPrices')) || []
            if (currentAlbum && albumId) {
                const priceCurrentAlbum = pricesFromStorage.find(item => item.id === albumId) || {}
                if (priceCurrentAlbum) {
                    setPrice(priceCurrentAlbum.price)
                }
            }
            // Calculate total amount of items in cart
            calculateAmountOfItems()
        } catch (error) {
            console.error(error)
        }
    }, [albumId, calculateAmountOfItems])

    const handleSpotifyButton = useCallback(() => {
        window.open(currentAlbum?.external_urls?.spotify, '_blank')
    }, [currentAlbum])

    return (
        <>
            <div className='releaseDetailsWrapper'>
                <div className='releaseDetails'>
                    <div className='releaseTitleAndArtistsAndSpotifyButton'>
                        <div className='releaseTitleAndSpotifyButton'>
                            <h2>{currentAlbum?.name}</h2>
                            <div className='spotifyButton' onClick={handleSpotifyButton}>
                                <p>Listen Here</p>
                                <img src={SpotifyLogo} alt='SpotifyLogo' />
                            </div>
                        </div>
                        <div className='releaseArtits'>
                            {currentAlbum?.artists?.map((artist, index, artists) => {
                                const artistName = artist.name
                                const isLastArtist = index === artists.length - 1
                                const separator = artists.length > 1 && !isLastArtist ? ',' : ''

                                return (
                                    <h4 className='artistName' key={artist.id}>{artistName + separator}</h4>
                                )
                            })}
                        </div>
                    </div>
                    <div className='releaseCoverArtInfoBuyButtonAndTracks'>
                        <div className='releaseCoverArt'>
                            {
                                Object.keys(currentAlbum).length !== 0 ? (
                                    <Canvas
                                        gl={{
                                            antialias: true,
                                            toneMapping: THREE.ACESFilmicToneMapping,
                                            outputEncoding: THREE.sRGBEncoding
                                        }}
                                        camera={{ position: [0, 0, 250] }}
                                        className='canvas'
                                    >
                                        <DetailsScene currentAlbum={currentAlbum} price={price} />
                                    </Canvas>

                                ) : (
                                    <div>
                                        <h2 className='loading'>Loading...</h2>
                                    </div>
                                )
                            }
                        </div>
                        <div className='titleAndTracksPlusInfo'>
                            <div className='releaseInfo'>
                                <div className='releasePriceAndType'>
                                    <p className='releaseType'>LP</p>
                                    <h4 className='releasePrice'>€ {price}</h4>
                                </div>
                            </div>
                            <div className='releaseDate'>
                                <p>{currentAlbum?.release_date}</p>
                            </div>
                            <div className='releaseLabelInfo'>
                                <h4 className='labelText'>LABEL</h4>
                                <h4 className='labelName'>{currentAlbum?.label}</h4>
                            </div>
                            <div className='extraTitle'>
                                <h2>{currentAlbum?.name}</h2>
                            </div>
                            <div className='releaseTracks'>
                                <h2>Tracks</h2>
                                {
                                    currentAlbum?.tracks?.items?.map(track => {
                                        return <p key={track?.track_number}>{track?.track_number} - {track?.name}</p>
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}